// src/routes/app/sessions/helpline.tsx
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { HelplineBookingDialog } from '@/features/sessions/components/shared/HelplineBookingDialog';
import { requirePermission } from '@/lib/guards';
import { useAuthStore } from '@/stores/authStore';

const searchSchema = z.object({
  clientId: z.string().optional(),
});

export const Route = createFileRoute('/app/sessions/helpline')({
  beforeLoad: () => {
    requirePermission('session:create');
  },
  component: HelplineScreen,
  validateSearch: searchSchema,
  staticData: { crumb: 'Helpline booking' },
});

function HelplineScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  if (!user?.businessAssociateId) {
    return <p className="p-4 text-sm">Account not linked to a BA.</p>;
  }

  if (!search.clientId) {
    return (
      <p className="p-4 text-sm">
        Pick a client first. Append <code>?clientId=US_xxx</code> to the URL.
      </p>
    );
  }

  return (
    <HelplineBookingDialog
      clientId={search.clientId}
      businessAssociateId={user.businessAssociateId}
      open
      onClose={() => {
        void navigate({ to: '/app/sessions', search: { drawerTab: 'overview', segment: 'all' } });
      }}
      onSuccess={(sessionId) => {
        void navigate({ to: '/app/sessions/$sessionId', params: { sessionId } });
      }}
    />
  );
}
